export const ACTIVE = 'Ativo'
export const EXPIRED = 'Expirado'
export const INACTIVE = 'Inativo'
export const PENDING = 'Pendente'
export const FROZEN = 'Congelado'
export const REMOVED = 'Removido'
export const DEFAULTER = 'Inadimplente'

export const DOCTOR_STATUS = [
  ACTIVE,
  FROZEN,
  REMOVED,
  DEFAULTER
]

export const DOCTOR_STATUS_PROPS = {
  [ACTIVE]: 'positive',
  [FROZEN]: 'blue-5',
  [REMOVED]: 'grey-6',
  [DEFAULTER]: 'orange-6'
}

export const ADMIN = 'Administrador'
export const DOCTOR = 'Médico'
export const MANAGER_VIEWER = 'Visualizador'
export const MANAGER_COORDINATOR = 'Coordenador'
export const MANAGER_ADMIN = 'Gestor Administrador'

export const PARTNER = 'Sócio'
export const EMPLOYEE = 'Funcionário'
export const THIRD = 'Terceiro'
export const doctorRoles = [PARTNER, EMPLOYEE]

export const doctorRoleOptions = [PARTNER, EMPLOYEE]

export const statusOptions = [
  ACTIVE,
  EXPIRED,
  INACTIVE,
  PENDING
]

export const statusColors = {
  [ACTIVE]: 'positive',
  [EXPIRED]: 'purple',
  [INACTIVE]: 'red-6',
  [PENDING]: 'orange',
  [FROZEN]: 'blue-5',
  [REMOVED]: 'grey-6',
  [DEFAULTER]: 'orange-6'
}

export const USER_STATUS_PROPS = {
  [ACTIVE]: { color: 'positive', label: ACTIVE },
  [EXPIRED]: { color: 'purple', label: 'Convite Expirado' },
  [INACTIVE]: { color: 'red-6', label: INACTIVE },
  [PENDING]: { color: 'orange', label: 'Convite Pendente' },
  [FROZEN]: { color: 'blue-5', label: FROZEN },
  [REMOVED]: { color: 'grey-6', label: REMOVED },
  [DEFAULTER]: { color: 'orange-6', label: DEFAULTER }
}

export const userTypes = [ADMIN, DOCTOR]

export const LOGIN_TYPE_MICROSOFT = 'microsoft'

export const LOGIN_TYPE_PASSWORD = 'password'

export const PARTNER_MIN_AGE = 18
export const PARTNER_MAX_AGE = 120

export const REGIME_FULL_COMMUNITY_PROPERTY = 'Comunhão Parcial de Bens'
export const REGIME_PARTIAL_COMMUNITY_PROPERTY = 'Comunhão Universal de Bens'
export const REGIME_CONVENTIONAL_SEPARATION_OF_PROPERTY = 'Separação Convencional de Bens'
export const REGIME_MANDATORY_SEPARATION_OF_PROPERTY = 'Separação Obrigatória de Bens'
export const REGIME_FINAL_PARTICIPATION_IN_ACQUISITIONS = 'Participação Final nos Aquestos'

export const MATRIMONIAL_REGIMES = [
  REGIME_FULL_COMMUNITY_PROPERTY,
  REGIME_PARTIAL_COMMUNITY_PROPERTY,
  REGIME_CONVENTIONAL_SEPARATION_OF_PROPERTY,
  REGIME_MANDATORY_SEPARATION_OF_PROPERTY,
  REGIME_FINAL_PARTICIPATION_IN_ACQUISITIONS
]

// New Users
export const LEAD_MANAGER = 'lead-manager'
export const ONBOARDING_MANAGER = 'onboarding-manager'
export const FORCE_LEAD_MANAGER = 'force-lead-to-register'
export const LEAD_SIMULATION_MANAGER = 'lead-simulation-manager'
export const COMMENT_REGISTER = 'comment-register'
export const COMMENT_LICENSE = 'comment-license'
export const COMMENT_ONBOARDING = 'comment-onboarding'

// Register

export const REGISTER_MANAGER = 'register-manager'
export const LICENSE_MANAGER = 'licenses-manager'

// Doctors
export const DOCTOR_MANAGER = 'doctor-manager'
export const USER_MANAGER = 'user-manager'
export const COMPANY_MANAGER = 'company-manager'
export const NATURAL_PERSON_MANAGER = 'natural-person-manager'
export const COMPANY_CERTIFICATES_MANAGER = 'company-certificates-manager'
export const DOCTOR_CERTIFICATES_MANAGER = 'doctor-certificates-manager'
export const UPDATE_INVOICE_ISSUE_STATUS = 'update-invoice-issue-status'
export const USER_EXPORT_MANAGER = 'users-export'
export const ENABLE_CHANGE_PF_TO_PJ = 'enable_change_pf_to_pj'
export const EXPORT_COMPANY_BANK_DATA = 'export-company-bank-data'
export const COMMENT_COMPANY = 'comment-company'
export const COMMENT_DIGITAL_CERTIFICATE = 'comment-digital-certificate'
export const CAN_CHANGE_COMPANY_OWNER_DOCTOR = 'can-change-company-owner-doctor'

// Billing
export const ACCOUNTS_RECEIVABLE_MANAGER = 'accounts-receivable-manager'
export const CLIENT_MANAGER = 'client-manager'
export const INVOICE_LOGS_MANAGER = 'invoice-logs-manager'
export const RECEIPT_MANAGER = 'receipt-manager'
export const ARCHIVE_INVOICE = 'archive-invoice'

// Monthly
export const CANCELED_NF_EXPORT = 'canceled-nf-export'
export const EXPORT_REGISTER_HISTORY = 'export-register-history'
export const EXPORT_STATEMENT_HISTORY = 'export-statement-history'
export const EXPORT_CLOSING_HISTORY = 'export-closing-history'
export const EXPORT_LICENSE_HISTORY = 'export-license-history'
export const EXPORT_NF_HISTORY = 'export-nf-history'
export const EXPORT_NF_ISSUE = 'export-nf-issue'
export const EXPORT_BOLETO = 'export-boleto'
export const UPLOAD_SHEET_TO_UPDATE_DOMINIO_FOLDER = 'can-mass-update-company-dominio-folder'
export const CLOSINGS_MANAGER = 'closings-manager'
export const CASH_BOOK_CLOSINGS_MANAGER = 'cash-book-closings-manager'
export const STATEMENT_MANAGER = 'statement-manager'
export const PRO_LABORE_MANAGER = 'pro-labore-manager'
export const DP_MANAGER = 'dp-manager'
export const TAXES_MANAGER = 'taxes-manager'
export const MONTHLY_OBLIGATIONS_MANAGER = 'monthly-obligations-manager'
export const R_FACTOR_MANAGER = 'r-factor-manager'
export const COMMENT_MONTHLY_OBLIGATION = 'comment-monthly-obligation'
export const COMMENT_R_FACTOR = 'comment-r-factor'
export const COMMENT_STATEMENT = 'comment-statement'

export const REQUEST_CONTRACT_SIGNATURE = 'request-contract-signature'

/**
 * ! Ao criar uma nova permissão para relatórios no módulo "Acompanhamento",
 * ! lembrar de adicioná-la ao array PROCESSION_REPORT_ROLES para dar visibilidade
 * ! da página, caso o usuário possua a permissão.
*/
export const PROCESSION_REPORT_ROLES = [
  CANCELED_NF_EXPORT,
  EXPORT_REGISTER_HISTORY,
  EXPORT_STATEMENT_HISTORY,
  EXPORT_CLOSING_HISTORY,
  EXPORT_LICENSE_HISTORY,
  EXPORT_NF_HISTORY,
  EXPORT_NF_ISSUE,
  EXPORT_BOLETO
]

// Boleto
export const BOLETO_MANAGER = 'boleto-manager'

// Financial
export const TRANSACTIONS_MANAGER = 'transactions-manager'
export const PLANS_MANAGER = 'plans-manager'
export const COUPONS_MANAGER = 'coupons-manager'
export const INDICATIONS_MANAGER = 'indications-manager'
export const MOVING_CUSTOMERS_BETWEEN_ASAAS_ACCOUNTS = 'moving-customers-between-asaas-account'

// Relationship
export const REQUESTS_MANAGER = 'requests-manager'
export const KNOWLEDGE_BASE_MANAGER = 'knowledge-base-manager'

// Calendar
export const CALENDAR_MANAGER = 'calendar-manager'
export const REPORTS_MANAGER = 'reports-manager'

// Configuration
export const CONFIGURATION_MANAGER = 'configuration-manager'
export const CONFIGURATION_MUNICIPAL = 'configuration-municipal'

// Media
export const MEDIA_MANAGER = 'media-manager'

// Advanced
export const ADMIN_MANAGER = 'admin-manager'
export const CAN_LOGOUT_USER = 'can-logout-user'
export const CAN_CHANGE_STATUS_ADMIN = 'can-change-status-admin'
export const TERMS_OF_SERVICE_MANAGER = 'terms-of-service-manager'
export const NEWS_MANAGER = 'newsletter-manager'
export const COLLEGE_MANAGER = 'college-manager'
export const NOTIFICATIONS_MANAGER = 'notifications-manager'
export const DEPARTMENT_MANAGER = 'department-manager'
export const NPS_MANAGER = 'nps-manager'
// export const LOGS_MANAGER = 'logs-manager'

// Cash Book
export const CASH_BOOK_MANAGER = 'cash-book-manager'
export const CASH_BOOK_UPDATES_MANAGER = 'cash-book-updates-manager'

// Duty
export const MANAGEMENT_GROUP_MANAGER = 'management-group-manager'
// export const ACCREDITATION_MANAGER = 'accreditation-manager' // TODO: Ajustar permissão do módulo de Credenciamento quando ligar com backend

export const DOCTOR_PERMISSION_BANK_SLIPS_MANAGER = 'bank-slips'
export const DOCTOR_PERMISSION_CASH_BOOK_MANAGER = 'cash-book'
export const DOCTOR_PERMISSION_CASH_FLOW_MANAGER = 'cash-flow'
export const DOCTOR_PERMISSION_CHARTS_MANAGER = 'charts'
export const DOCTOR_PERMISSION_CLIENTS_MANAGER = 'clients'
export const DOCTOR_PERMISSION_COMPANY_MANAGER = 'company'
export const DOCTOR_PERMISSION_FILES_MANAGER = 'files'
export const DOCTOR_PERMISSION_INVOICES_MANAGER = 'invoices'
export const DOCTOR_PERMISSION_RECEIPTS_MANAGER = 'receipts'
export const DOCTOR_PERMISSION_STATEMENTS_MANAGER = 'statements'
export const DOCTOR_PERMISSION_VIEW_ALL_INVOICES_MANAGER = 'view-all-invoices'
export const DOCTOR_PERMISSION_CALENDAR_MANAGER = 'calendar'
export const DOCTOR_PERMISSION_REPORTS_MANAGER = 'reports'

// IRPF
export const PERSONAL_INCOME_TAX_MANAGER = 'personal-income-tax-manager'
export const PERSONAL_INCOME_TAX_CONFIGURATION_MANAGER = 'personal-income-tax-configuration-manager'
export const COMMENT_PERSONAL_INCOME_TAX = 'comment-personal-income-tax'

// CREDENTIALS
export const COMPANY_CREDENTIALS_MANAGER = 'company-credentials-manager'
export const DOCTOR_CREDENTIALS_MANAGER = 'doctor-credentials-manager'

export const groupedRoleTypes = [
  {
    label: 'Novos',
    icon: 'assignment_ind',
    roles: [
      { label: 'Leads', value: LEAD_MANAGER },
      { label: 'Onboarding', value: ONBOARDING_MANAGER },
      { label: 'Comentários em Onboarding', value: COMMENT_ONBOARDING, enableModule: false },
      { label: 'Leads - Simulação', value: LEAD_SIMULATION_MANAGER },
      { label: 'Indicações', value: INDICATIONS_MANAGER },
      { label: 'Forçar Lead para Registro', value: FORCE_LEAD_MANAGER, onlyEdit: true }
    ]
  },
  {
    label: 'Registro',
    icon: 'domain_add',
    roles: [
      { label: 'Abertura', value: REGISTER_MANAGER },
      { label: 'Comentários em Abertura', value: COMMENT_REGISTER, enableModule: false },
      { label: 'Licenciamento', value: LICENSE_MANAGER },
      { label: 'Comentários em Licenciamento', value: COMMENT_LICENSE, enableModule: false }
    ]
  },
  {
    label: 'Médicos',
    icon: 'medical_information',
    roles: [
      { label: 'Geral', value: DOCTOR_MANAGER },
      { label: 'Usuários', value: USER_MANAGER },
      { label: 'Empresas', value: COMPANY_MANAGER },
      { label: 'Comentários em Histórico de Empresa', value: COMMENT_COMPANY, enableModule: false },
      { label: 'Alterar Sócio Dono de Empresa', value: CAN_CHANGE_COMPANY_OWNER_DOCTOR, onlyEdit: true },
      { label: 'Pessoas Físicas', value: NATURAL_PERSON_MANAGER },
      { label: 'Habilitar / Desabilitar Emissão de NF', value: UPDATE_INVOICE_ISSUE_STATUS, onlyEdit: true },
      { label: 'Habilitar exportação de planilhas de Usuários', value: USER_EXPORT_MANAGER, onlyEdit: true },
      { label: 'Certificado Digital (Empresa)', value: COMPANY_CERTIFICATES_MANAGER },
      { label: 'Comentários em Certificado Digital (Empresa)', value: COMMENT_DIGITAL_CERTIFICATE, enableModule: false },
      { label: 'Certificado Digital (Médico)', value: DOCTOR_CERTIFICATES_MANAGER },
      { label: 'Habilitar transformação de Médico PF para PJ', value: ENABLE_CHANGE_PF_TO_PJ, onlyEdit: true },
      { label: 'Relatório de Dados Bancários', value: EXPORT_COMPANY_BANK_DATA, onlyEdit: true },
      { label: 'Credenciais (Empresa)', value: COMPANY_CREDENTIALS_MANAGER },
      { label: 'Credenciais (Médico)', value: DOCTOR_CREDENTIALS_MANAGER }
    ]
  },
  {
    label: 'Faturamento',
    icon: 'attach_money',
    roles: [
      { label: 'Contas a Receber', value: ACCOUNTS_RECEIVABLE_MANAGER },
      { label: 'Tomadores', value: CLIENT_MANAGER },
      { label: 'Recibos', value: RECEIPT_MANAGER },
      { label: 'Arquivar / Desarquivar Notas Fiscais', value: ARCHIVE_INVOICE, onlyEdit: true }
      // { label: 'Logs', value: INVOICE_LOGS_MANAGER }
    ]
  },
  {
    label: 'Mensal',
    icon: 'o_verified',
    roles: [
      { label: 'Relatório de Registro', value: EXPORT_REGISTER_HISTORY, onlyEdit: true, enableModule: true },
      { label: 'Relatório de Faturamento', value: EXPORT_NF_HISTORY, onlyEdit: true, enableModule: true },
      { label: 'Relatório de Histórico de Licenciamento', value: EXPORT_LICENSE_HISTORY, onlyEdit: true, enableModule: true },
      { label: 'Relatório de Fechados', value: EXPORT_CLOSING_HISTORY, onlyEdit: true, enableModule: true },
      { label: 'Relatório de Histórico de Extratos', value: EXPORT_STATEMENT_HISTORY, onlyEdit: true, enableModule: true },
      { label: 'Relatório de Notas Fiscais', value: EXPORT_NF_ISSUE, onlyEdit: true, enableModule: true },
      { label: 'Relatório de NFs Canceladas', value: CANCELED_NF_EXPORT, onlyEdit: true, enableModule: true },
      { label: 'Relatório de Boletos', value: EXPORT_BOLETO, onlyEdit: true, enableModule: true },
      { label: 'Atualizar nomes de Pasta Domínio', value: UPLOAD_SHEET_TO_UPDATE_DOMINIO_FOLDER, onlyEdit: true },
      { label: 'Fechados (PJ)', value: CLOSINGS_MANAGER },
      { label: 'Fechados (Livro Caixa)', value: CASH_BOOK_CLOSINGS_MANAGER },
      { label: 'Extratos', value: STATEMENT_MANAGER },
      { label: 'Comentários em Extratos', value: COMMENT_STATEMENT, enableModule: false },
      { label: 'Obrigações Mensais', value: MONTHLY_OBLIGATIONS_MANAGER },
      { label: 'Comentários em Obrigações Mensais', value: COMMENT_MONTHLY_OBLIGATION, enableModule: false },
      { label: 'Fator R', value: R_FACTOR_MANAGER },
      { label: 'Comentários em Detalhes do Fator R', value: COMMENT_R_FACTOR, enableModule: false }
      // { label: 'Pró-Labore', value: PRO_LABORE_MANAGER },
      // { label: 'DP', value: DP_MANAGER },
      // { label: 'Impostos', value: TAXES_MANAGER }
    ]
  },
  {
    label: 'Boletos',
    icon: 'request_quote',
    roles: [
      { label: 'Boletos', value: BOLETO_MANAGER }
    ]
  },
  {
    label: 'Financeiro',
    icon: 'account_balance',
    roles: [
      { label: 'Transações', value: TRANSACTIONS_MANAGER },
      { label: 'Planos', value: PLANS_MANAGER },
      { label: 'Cupons', value: COUPONS_MANAGER },
      { label: 'Mover Empresa de Conta Asaas', value: MOVING_CUSTOMERS_BETWEEN_ASAAS_ACCOUNTS },
      { label: 'Solicitar Assinatura de Contrato', value: REQUEST_CONTRACT_SIGNATURE, onlyEdit: true }

    ]
  },
  {
    label: 'Livro Caixa',
    icon: 'menu_book',
    roles: [
      { label: 'Geral', value: CASH_BOOK_MANAGER },
      { label: 'Atualizações', value: CASH_BOOK_UPDATES_MANAGER }
    ]
  },
  // {
  //   label: 'Suporte',
  //   roles: [
  //     { label: 'Solicitações', value: REQUESTS_MANAGER },
  //     { label: 'Base de Conhecimento', value: KNOWLEDGE_BASE_MANAGER }
  //   ]
  // },
  {
    label: 'Agenda',
    icon: 'event',
    roles: [
      { label: 'Calendário', value: CALENDAR_MANAGER },
      { label: 'Relatórios', value: REPORTS_MANAGER }
    ]
  },
  {
    label: 'DocPlantão',
    icon: 'medical_services',
    roles: [
      { label: 'Gestores', value: MANAGEMENT_GROUP_MANAGER }
      // { label: 'Credenciamento', value: ACCREDITATION_MANAGER }
    ]
  },
  {
    label: 'IRPF',
    icon: 'currency_exchange',
    roles: [
      { label: 'IRPF', value: PERSONAL_INCOME_TAX_MANAGER },
      { label: 'Comentários em Detalhes do IRPF', value: COMMENT_PERSONAL_INCOME_TAX, enableModule: false },
      { label: 'Configuração de IRPF', value: PERSONAL_INCOME_TAX_CONFIGURATION_MANAGER }
    ]
  },
  {
    label: 'Parâmetros',
    icon: 'tune',
    roles: [
      { label: 'Parâmetros Contábeis', value: CONFIGURATION_MANAGER },
      { label: 'Parâmetros Municipais', value: CONFIGURATION_MUNICIPAL },
      { label: 'Configuração de IRPF', value: PERSONAL_INCOME_TAX_CONFIGURATION_MANAGER }
    ]
  },
  {
    label: 'Vídeos',
    icon: 'ondemand_video',
    roles: [
      { label: 'Vídeos', value: MEDIA_MANAGER }
    ]
  },
  {
    label: 'Avançado',
    icon: 'construction',
    roles: [
      { label: 'Analistas', value: ADMIN_MANAGER },
      { label: 'Forçar Deslogar Usuários', value: CAN_LOGOUT_USER, onlyEdit: true },
      { label: 'Termos de Serviços', value: TERMS_OF_SERVICE_MANAGER },
      { label: 'Notificações', value: NOTIFICATIONS_MANAGER },
      { label: 'Novidades', value: NEWS_MANAGER },
      { label: 'Ativar/Inativar Analistas', value: CAN_CHANGE_STATUS_ADMIN, onlyEdit: true },
      { label: 'Faculdades', value: COLLEGE_MANAGER },
      { label: 'NPS', value: NPS_MANAGER },
      { label: 'Setores', value: DEPARTMENT_MANAGER }
      // { label: 'Logs', value: LOGS_MANAGER }
    ]
  }
]

export const roleTypes = groupedRoleTypes.flatMap(group => {
  return group.roles.map(role => {
    return {
      label: group.label !== role.label
        ? `${group.label} - ${role.label}`
        : role.label,
      value: role.value,
      onlyEdit: role.onlyEdit
    }
  })
})

export const PERMISSION_VIEW = 'view'
export const PERMISSION_EDIT = 'edit'
export const PERMISSION_DELETE = 'delete'
export const permissionTypes = [
  { label: 'Visualizar', value: PERMISSION_VIEW },
  { label: 'Criar/Editar', value: PERMISSION_EDIT },
  { label: 'Excluir', value: PERMISSION_DELETE }
]

export const groupedEmployeeRolesTypes = [
  { label: 'Boletos', value: DOCTOR_PERMISSION_BANK_SLIPS_MANAGER, hidedOptions: [PERMISSION_DELETE] },
  { label: 'Entradas e Saídas', value: DOCTOR_PERMISSION_CASH_FLOW_MANAGER, only: PERMISSION_VIEW },
  { label: 'Gráficos', value: DOCTOR_PERMISSION_CHARTS_MANAGER, only: PERMISSION_VIEW },
  { label: 'Tomadores', value: DOCTOR_PERMISSION_CLIENTS_MANAGER, hidedOptions: [PERMISSION_DELETE] },
  // { label: 'Empresa', value: DOCTOR_PERMISSION_COMPANY_MANAGER },
  { label: 'Arquivos', value: DOCTOR_PERMISSION_FILES_MANAGER, only: PERMISSION_VIEW },
  { label: 'Notas Fiscais', value: DOCTOR_PERMISSION_INVOICES_MANAGER },
  {
    label: 'Visualizar todas as Notas Fiscais',
    value: DOCTOR_PERMISSION_VIEW_ALL_INVOICES_MANAGER,
    only: PERMISSION_VIEW,
    tooltip: 'Ao ativar esta permissão, o funcionário poderá visualizar todas as notas fiscais emitidas pela empresa,' +
      ' independentemente de ter realizado a solicitação ou não. Em contrapartida, se essa permissão estiver desabilitada,' +
      ' só visualizará as NFs que ele solicitou.'
  },
  { label: 'Extratos', value: DOCTOR_PERMISSION_STATEMENTS_MANAGER, hidedOptions: [PERMISSION_DELETE] },
  { label: 'Calendário', value: DOCTOR_PERMISSION_CALENDAR_MANAGER },
  { label: 'Relatórios', value: DOCTOR_PERMISSION_REPORTS_MANAGER, only: PERMISSION_VIEW }
]

export const DEFAULT_CRM_CREDENTIALS = {
  login: '',
  password: '',
  state: ''
}

export const DEFAULT_ADDRESS = {
  cep: '',
  city: '',
  state: '',
  neighborhood: '',
  street: '',
  number: '',
  complement: '',
  city_id: null,
  state_id: null
}

export const DEFAULT_DOCTOR = {
  cpf: '',
  rg: '',
  ctps: '',
  birth_city: '',
  doctor_college: null,
  college_id: null,
  birth_date: '',
  marital_status: '',
  status: ACTIVE,
  address: { ...DEFAULT_ADDRESS },
  is_resident_doctor: false,
  serve_armed_forces: false,
  permanent_employee: false,
  has_fies: false,
  is_certificate_expired: false,
  nf_requirements: '',
  free_personal_income_taxes: []
}

export const DEFAULT_USER = {
  name: '',
  email: '',
  notifications_email: ''
}

export const DEFAULT_DOCTOR_USER = {
  ...DEFAULT_USER,
  role: PARTNER,
  company_id: null,
  send_invite_for_partner: true,
  doctor: { ...DEFAULT_DOCTOR }
}

export const DEFAULT_EMPLOYEE_USER = {
  ...DEFAULT_USER,
  role: EMPLOYEE
}

export const DEFAULT_THIRD_MEMBER = {
  name: '',
  cpf: '',
  email: '',
  phone: ''
}

// Caso o campo esteja dentro de algum objeto e seja um array, é necessário colocar o path completo.
export const arrayFields = [
  'doctor.crms',
  'doctor.free_personal_income_taxes'
]

export const jsonFields = [
  'doctor',
  'doctor.address'
]

export const keysToIgnore = [
  'doctor.college_id',
  'doctor.address.city_id',
  'doctor.address.state_id',
  'doctor.address.ibge'
]
